import axios from "axios";

export async function getPurchaseOrder(token:string, params:any): Promise<any> {
    try {
      const response = await axios.get(process.env.REACT_APP_BASE_URL+`/ordemcompra/usuario`, {
        params,
        headers: {
            Authorization: 'Bearer ' + token
        }
        });
  
      return response.data; // Supondo que as requisições sejam retornados pelo backend
    } catch (error) {
      throw new Error('Falha na autenticação');
    }
}

export async function getPurchaseOrderDashboard(token:string, params: any): Promise<any> {
  try {
    const response = await axios.get(process.env.REACT_APP_BASE_URL+`/ordemcompra/dashboard`, {
      params,
      headers: {
          Authorization: 'Bearer ' + token
      }
      });

    return response.data; // Supondo que as requisições sejam retornados pelo backend
  } catch (error) {
    throw new Error('Falha na autenticação');
  }
}